import { IntegrationLocalEntities } from './IntegrationLocalEntityEnum'

/**
 * Defines the specific local entity URNs that are allowed for EntitySyncConfiguration.
 * These are a subset of all possible IntegrationLocalEntityEnum values.
 */
export const EntitySyncConfigurationEntities = {
  VENDOR: IntegrationLocalEntities.VENDOR,
  ACCOUNT_CODE: IntegrationLocalEntities.ACCOUNT_CODE,
  PAYMENT: IntegrationLocalEntities.PAYMENT,
} as const

/**
 * Type representing the allowed local entity URNs for an EntitySyncConfiguration.
 * Derived from the EntitySyncConfigurationEntities object to ensure consistency.
 */
export type EntitySyncConfigurationEntityEnum =
  (typeof EntitySyncConfigurationEntities)[keyof typeof EntitySyncConfigurationEntities]

/**
 * An array of the allowed entity URNs for runtime validation.
 * Derived from the EntitySyncConfigurationEntities object.
 */
export const ALLOWED_ENTITY_SYNC_CONFIG_ENTITIES: readonly EntitySyncConfigurationEntityEnum[] =
  Object.values(EntitySyncConfigurationEntities)
